import React from 'react';
import {JOURNEYS} from "../../../constants";
import {Elements} from "@stripe/react-stripe-js";
import {loadStripe} from "@stripe/stripe-js";
import StripeChargeForm from "./Components/StripeChargeForm";

const STRIPE_PROMISE = loadStripe(window.stripe.public_key);

const StripeSubscriptionPage = (props) => {
    const {
        previousPage    = () => {},
        nextPage        = () => {},
        journey         = JOURNEYS.AGENT,
    } = props;

    return (
        <Elements stripe={STRIPE_PROMISE}>
            <StripeChargeForm
                journey={journey}
                previousPage={previousPage}
                nextPage={nextPage}
            />
        </Elements>
    );
}

export default StripeSubscriptionPage;
